<template>
	<div>
		<div style="height: 80px;"></div>
		<div class="citys">
			<div class="padding-md text-left margin-top-md">
				<h3>热门城市</h3>
				<ul class="hotCity">
					<li v-for="(cItem, cIndex) in hotCitys" :key='cIndex' @click='changeCity(cItem)'>{{ cItem }}</li>
				</ul>
			</div>
			<div class="padding-md text-left">
				<h3>拼音首字母排列城市</h3>
				<div class="padding-tb-lg">
					<el-table :data="tableData" style="width: 100%" border>
						<el-table-column prop="date" label="全国">
							<template slot-scope="scope">
								<div class="flex">
									<div style="min-width: 50px;max-height: 30px;line-height: 30px;font-size: 20px;font-weight: 700;text-align: center;
										background-color: #0c8bff;color: #fff;border-radius: 15px;margin-right: 30px;">
										{{ scope.row.key }}
									</div>
									<div class="flex flex-warp">
										<div v-for="item in scope.row.data" :key='item' class="city"
											style="font-size: 16px;margin-right: 20px;height: 30px;line-height: 30px;cursor: pointer;"
											 @click='changeCity(item)'>
											{{ item }}
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "@/components/layout/header"
	// import Footer from "@/components/layout/footer"
	export default {
		components: {
			Header
		},
		data() {
			return {
				hotCitys: ['全国', '杭州', '北京', '长沙', '上海', '深圳', '南京', '武汉', '广州'],
				tableData: [
					{
						key: 'A',
						data: ['阿拉善盟', '鞍山', '安庆', '安阳', '阿坝藏族羌族自治州', '安顺', '阿里地区', '安康', '阿克苏地区', '阿勒泰地区', '阿拉尔', '澳门特别行政区']
					},{
						key: 'B',
						data: ['北京', '保定', '包头',  '巴彦淖尔', '本溪', '白山', '白城', '蚌埠', '亳州', '滨州', '北海', '百色', '巴中', '保山', '宝鸡', '白银', '博尔塔拉蒙古自治州', '巴音郭楞蒙古自治州', '北屯', '白沙黎族自治县', '毕节', '保亭黎族苗族自治县']
					},{
						key: 'C',
						data: ['承德', '沧州', '长治', '赤峰', '朝阳', '长春', '常州', '滁州', '池州', '长沙', '常德', '郴州', '潮州', '崇左', '重庆', '成都', '楚雄黎族自治州', '昌吉回族自治州', '昌江黎族自治县', '澄迈县' , '重庆郊县', '昌都']
					},{
						key: 'D',
						data: ['大同', '大连', '丹东', '大庆', '大兴安岭地区', '东营', '德州', '东莞', '德阳', '达州', '大理白族自治州', '德宏傣族景颇族自治州', '迪庆藏族自治州', '定西', '儋州', '东方', '定安县']
					},{
						key: 'E',
						data: ['鄂尔多斯', '鄂州', '恩施土家族苗族自治州']
					},{
						key: 'F',
						data: ['抚顺', '阜新', '阜阳', '福州', '抚州', '佛山', '防城港']
					},{
						key: 'G',
						data: ['赣州', '广州', '桂林', '贵港', '广元', '广安', '甘孜藏族自治州', '贵阳', '甘南藏族自治州', '果洛藏族自治州', '固原']
					},{
						key: 'H',
						data: ['邯郸', '衡水', '呼和浩特', '呼伦贝尔', '葫芦岛', '哈尔滨', '鹤岗', '黑河', '淮安', '杭州', '湖州', '合肥', '淮南', '淮北', '黄山', '菏泽', '鹤壁', '黄石', '黄冈', '衡阳', '怀化', '惠州', '河源', '贺州', '河池', '海口', '红河哈尼族彝族自治州', '汉中', '海北藏族自治州', '黄南藏族自治州', '海南藏族自治州', '海西蒙古族藏族自治州', '和田地区', '哈密', '海东', '胡杨河']
					},{
						key: 'J',
						data: ['晋城', '晋中', '锦州', '吉林', '鸡西', '佳木斯', '嘉兴', '金华', '景德镇', '九江', '吉安', '济南', '济宁', '焦作', '荆门', '荆州', '江门', '揭阳', '嘉峪关', '金昌', '酒泉', '济源']
					},{
						key: 'K',
						data: ['开封', '昆明', '克拉玛依', '克孜勒苏柯尔克孜自治州', '喀什地区', '可克达拉', '昆玉']
					},{
						key: 'L',
						data: ['廊坊', '临汾', '吕梁', '辽阳', '辽源', '连云港', '丽水', '六安', '龙岩', '临沂', '聊城', '漯河', '洛阳', '娄底', '柳州', '来宾', '泸州', '乐山', '凉山彝族自治州', '六盘水', '丽江', '临沧', '拉萨', '兰州', '陇南', '临夏回族自治州', '临高县', '乐东黎族自治县', '陵水黎族自治县', '林芝'], 
					},{
						key: 'M',
						data: ['牡丹江', '马鞍山', '茂名', '梅州', '绵阳', '眉山']
					},{
						key: 'N',
						data: ['南京', '南通', '宁波', '南平', '宁德', '南昌', '南阳', '内江', '南充', '怒江傈僳族自治州', '那曲']
					},{
						key: 'P',
						data: ['盘锦', '莆田', '萍乡', '平顶山', '濮阳', '攀枝花', '平凉']
					},{
						key: 'Q',
						data: ['秦皇岛', '齐齐哈尔', '七台河', '衢州', '泉州', '青岛', '清远', '钦州', '黔西南布依族苗族自治州', '黔东南苗族侗族自治州', '曲靖', '庆阳', '琼中黎族苗族自治县', '琼海', '潜江']
					},{
						key: 'R',
						data: ['日照', '日喀则']
					},{
						key: 'S',
						data: ['石家庄', '朔州', '沈阳', '四平', '松原', '双鸭山', '绥化', '上海', '苏州', '宿迁', '绍兴', '宿州', '三明', '上饶', '三门峡', '商丘', '十堰', '随州', '邵阳', '韶关', '深圳', '汕头', '汕尾', '三亚', '遂宁', '商洛', '石嘴山', '石河子', '神农架林区', '三沙', '山南', '双河']
					},{
						key: 'T',
						data: ['天津', '唐山', '太原', '通辽', '铁岭', '通化', '泰州', '台州', '铜陵', '泰安', '铜川', '天水', '塔城地区', '图木舒克', '台湾', '铜仁', '吐鲁番', '屯昌县', '铁门关', '天门']
					},{
						key: 'W',
						data: ['乌海', '乌兰察布', '无锡', '温州', '芜湖', '潍坊', '威海', '武汉', '梧州', '文山壮族苗族自治州', '淮南', '武威', '吴忠', '乌鲁木齐', '五家渠', '五指山', '文昌', '万宁']
					},{
						key: 'X',
						data: ['邢台', '忻州', '兴安盟', '锡林郭勒盟', '徐州', '宣城', '厦门', '新余', '新乡', '许昌', '信阳', '襄阳', '孝感', '咸宁', '湘潭', '湘西土家族苗族自治州', '双西版纳傣族自治州', '西安', '咸阳', '西宁', '香港特别行政区', '仙桃']
					},{
						key: 'Y',
						data: ['阳泉', '运城', '营口', '延边朝鲜族自治州', '伊春', '盐城', '扬州', '鹰潭', '宜春', '烟台', '岳阳', '益阳', '永州', '阳江', '云浮', '玉林', '宜宾', '雅安', '玉溪', '延安', '榆林', '玉树藏族自治州', '银川', '伊犁哈萨克自治州']
					},{
						key: 'Z',
						data: ['张家口', '镇江', '舟山', '漳州', '淄博', '枣庄', '郑州', '周口', '驻马店', '株洲', '张家界', '珠海', '湛江', '肇庆', '中山', '自贡', '资阳', '遵义', '昭通', '张掖', '中卫']
					}
				]
			}
		},
		methods: {
			backHome(){
				this.$router.replace('/');
			},
			changeCity(item) {
				if(item == '全国'){
					window.localStorage.setItem('Citys', JSON.stringify({ city: '全国', cityValue: '' }));
					this.$router.go(-1);
					return
				}
				window.localStorage.setItem('Citys', JSON.stringify({ city: item, cityValue: item }))
				this.$router.go(-1);
			}
		},
	}
</script>

<style scoped lang="scss">
	.citys {
		width: 1200px;
		margin: 0 auto;

		.hotCity {
			display: flex;
			padding: 20px 0;

			li {
				margin-right: 20px;
				cursor: pointer;
			}
			li:hover {
				color: #0c8bff;
			}
		}
		.city{
			display: flex;
			flex-wrap: wrap;
		}
		.city:hover{
			color: #0c8bff;
		}
	}
</style>
